// extracted by mini-css-extract-plugin
export default {"app":"App_app__D8Swx","navbar":"App_navbar__t1bO5","content":"App_content__lm6sn"};